import { useEffect, useState } from 'react'
import { MEDIA_WIDTHS } from 'theme'

interface Props {
  width: number
  height: number
  isMobile: boolean
  isTablet: boolean
  isDesktop: boolean
}

export const useWindowSize = (): Props => {
  const [windowSize, setWindowSize] = useState({
    //Default State
    width: window.innerWidth,
    height: window.innerHeight,
    isMobile: window.innerWidth <= MEDIA_WIDTHS.Mobile.to,
    isTablet:
      window.innerWidth >= MEDIA_WIDTHS.Tablet.from && window.innerWidth <= MEDIA_WIDTHS.Tablet.to,
    isDesktop: window.innerWidth >= MEDIA_WIDTHS.Desktop.from,
  })

  // Update function
  function changeWindowSize() {
    setWindowSize({
      width: window.innerWidth,
      height: window.innerHeight,
      // < 639
      isMobile: window.innerWidth <= MEDIA_WIDTHS.Mobile.to,
      // > 640 && <= 1023
      isTablet:
        window.innerWidth >= MEDIA_WIDTHS.Tablet.from &&
        window.innerWidth <= MEDIA_WIDTHS.Tablet.to,
      // > 1024
      isDesktop: window.innerWidth >= MEDIA_WIDTHS.Desktop.from,
    })
  }

  useEffect(() => {
    window.addEventListener('resize', changeWindowSize)

    return () => {
      window.removeEventListener('resize', changeWindowSize)
    }
  }, [])

  return windowSize
}
